<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active">
            <router-link to="/reports">Reports</router-link>
          </li>
          <li class="active">Invalid Coupons</li>
        </ol>
        <div class="row">
          <div class="col-md-12">
            <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
              {{ SuccessMessage }}
            </div>
            <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
              {{ ErrorMessage }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div id="search-box">
              <div class="form-group">
                <input
                  type="text"
                  class="search-query form-control"
                  placeholder="Search by coupon code, partner type"
                  v-model="searchText"
                />
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <select
                id="statusFilter"
                class="form-control"
                v-model="statusFilter"
                @change="getInvalidCoupons(1)"
              >
                <option value="All">All</option>
                <option value="Invalid">Invalid</option>
                <option value="Accepted">Accepted</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <button
                type="button"
                v-on:click="getInvalidCoupons(1)"
                class="btn btn-raised btn-primary submitbtn"
              >
                Search
              </button>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <button
                type="button"
                @click="exportInvalidCoupons"
                class="btn btn-raised btn-success"
              >
                Export to CSV
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-default visibility" id="panel-inline">
              <div class="panel-heading">
                <h3 class="panel-title">Invalid Coupons Report</h3>
                <div class="panel-ctrls"></div>
              </div>
              <div class="panel-body no-padding visibility">
                <table
                  class="table table-striped table-bordered"
                  cellspacing="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Coupon Code</th>
                      <th>Partner Type</th>
                     
                      <th>Partner Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Scan Date</th>
                      <th>Points</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in invalid_coupons_data"
                      :key="item.id"
                      class="gradeC"
                    >
                      <td>{{ currentPage * pageSize + index + 1 }}</td>
                      <td class="left-align">
                        {{ item.coupon_code }}
                      </td>
                      <td>{{ item.partner_type }}</td>
                      
                      <td>{{ (item.partner_first_name || '') + ' ' + (item.partner_last_name || '') }}</td>
                      <td>{{ item.partner_email || 'N/A' }}</td>
                      <td>{{ item.partner_phone || 'N/A' }}</td>
                      <td>{{ item.scan_date | dateFormatReadable }}</td>
                      <td>{{ item.points || 'N/A' }}</td>
                      <td>
                        <span 
                          :class="getStatusClass(item.status)"
                        >
                          {{ item.status }}
                        </span>
                      </td>
                      <td>
                        <template v-if="item.status !== 'Rejected' && item.status !== 'Accepted'">
                          <button
                             type="button"
                             @click="openAcceptModal(item)"
                             class="btn btn-raised btn-success"
                           >Accept
                           </button>
 
                           <button type="button" class="btn btn-raised btn-danger" @click="rejectCoupon(item.id)">Reject</button>
                           
                        </template>
                      </td>
                    </tr>
                    <tr v-if="invalid_coupons_data.length === 0">
                      <td colspan="10" class="text-center">No invalid coupons found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="panel-footer">
                <paginate
                  :page-count="TotalPage"
                  :click-handler="getInvalidCoupons"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for Accept Coupon -->
    <div v-if="showAcceptModal" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Accept Invalid Coupon</h4>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitAcceptCoupon">
                <div class="form-group">
                  <label for="productDropdown">Product <span style="color:red">*</span></label>
                  <v-select
                    id="productDropdown"
                    :options="productsList"
                    label="ProductName"
                    :reduce="product => product"
                    :filterable="true"
                    :searchable="true"
                    :clearable="true"
                    :get-option-label="formatProductLabel"
                    v-model="selectedProduct"
                    placeholder="Select Product"
                  />
                </div>
                <div class="form-group">
                  <label for="reborerDropdown">Reborer <span style="color:#6c757d; font-size:0.85em;">(Optional)</span></label>
                  <v-select
                    id="reborerDropdown"
                    :options="reborersList"
                    label="first_name"
                    :reduce="reborer => reborer"
                    :filterable="true"
                    :searchable="true"
                    :clearable="true"
                    :get-option-label="formatReborerLabel"
                    v-model="selectedReborer"
                    placeholder="Select Reborer (Optional)"
                  />
                </div>
                <div v-if="acceptFormError" class="text-danger">{{ acceptFormError }}</div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-success text-white">Accept Coupon</button>
                  <button type="button" class="btn btn-secondary ml-2" @click="closeAcceptModal">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for Reject Coupon -->
    <div v-if="showRejectModal" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Reject Coupon</h4>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to reject this coupon?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-raised btn-danger" @click="confirmRejectCoupon">Yes, Reject</button>
              <button type="button" class="btn btn-secondary ml-2" @click="cancelRejectCoupon">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'InvalidCoupons',
  components: {
    Paginate,
    vSelect
  },
  data() {
    return {
      invalid_coupons_data: [],
      searchText: '',
      statusFilter: 'All', // Add status filter with default value
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      totalItems: 0,
      SuccessMessage: '',
      ErrorMessage: '',
      showAcceptModal: false,
      selectedCoupon: null,
      selectedProduct: null, // for product dropdown
      selectedReborer: null, // for reborer dropdown
      productsList: [], // list of products
      reborersList: [], // list of reborers
      acceptFormError: '',
      // Add for reject modal
      showRejectModal: false,
      selectedRejectCouponId: null,
    };
  },
  methods: {
    getRequestParams(searchText, page, pageSize, statusFilter) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      if (statusFilter && statusFilter !== 'All') {
        params['statusFilter'] = statusFilter;
      }

      return params;
    },

    getInvalidCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize,
        this.statusFilter
      );

      commonServices
        .get('kspgAPI/CouponOperations/invalidCouponsList', params)
        .then((response) => {
          const {
            invalid_coupons_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.invalid_coupons_data = invalid_coupons_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.totalItems = totalItems;
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          } else {
            this.ErrorMessage = (e.response && e.response.data && e.response.data.message) || 'Error fetching invalid coupons';
            setTimeout(() => { this.ErrorMessage = ''; }, 4000);
          }
        });
      this.skyloEnd();
      setTimeout(() => {
        loader.hide();
      }, 2000);
    },

    exportInvalidCoupons() {
      this.skyloStart();
      let loader = this.$loading.show();
      // Use a large page size to get all records
      const params = this.getRequestParams(this.searchText, 1, 10000, this.statusFilter);
      commonServices
        .get('kspgAPI/CouponOperations/invalidCouponsList', params)
        .then((response) => {
          const data = response.data.invalid_coupons_data;
          const headers = [
            'Coupon Code',
            'Partner Type',
           
            'Partner Name',
            'Email',
            'Phone',
            'Scan Date',
            'Status'
          ];
          const csvContent = [
            headers.join(','),
            ...data.map(item => [
              `"${item.coupon_code}"`,
              `"${item.partner_type || 'N/A'}"`,
             
              `"${(item.partner_first_name || '') + ' ' + (item.partner_last_name || '')}"`,
              `"${item.partner_email || 'N/A'}"`,
              `"${item.partner_phone || 'N/A'}"`,
              `"${item.scan_date || ''}"`,
              `"${item.status || ''}"`
            ].join(','))
          ].join('\n');

          // Download CSV file
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', `invalid_coupons_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          } else {
            this.ErrorMessage = (e.response && e.response.data && e.response.data.message) || 'Error exporting invalid coupons';
            setTimeout(() => { this.ErrorMessage = ''; }, 4000);
          }
        });
      this.skyloEnd();
      setTimeout(() => {
        loader.hide();
      }, 2000);
    },
    acceptCoupon(id) {
      if (!confirm('Are you sure you want to accept this coupon?')) return;
      let loader = this.$loading.show();
      commonServices
        .post('kspgAPI/CouponOperations/acceptInvalidCoupon', { id })
        .then((response) => {
          this.SuccessMessage = response.data.message;
          setTimeout(() => {
            this.getInvalidCoupons(this.currentPage);
            this.SuccessMessage = '';
          }, 2000);
        })
        .catch((e) => {
          this.ErrorMessage = (e.response && e.response.data && e.response.data.message) || 'Error accepting coupon';
          setTimeout(() => { this.ErrorMessage = ''; }, 4000);
        })
        .finally(() => loader.hide());
    },
    rejectCoupon(id) {
      this.selectedRejectCouponId = id;
      this.showRejectModal = true;
    },
    confirmRejectCoupon() {
      let id = this.selectedRejectCouponId;
      this.showRejectModal = false;
      this.selectedRejectCouponId = null;
      let loader = this.$loading ? this.$loading.show() : null;
      this.ErrorMessage = '';
      this.SuccessMessage = '';
      this.skyloStart && this.skyloStart();
      (this.$commonServices ? this.$commonServices : (window.commonServices || commonServices))
        .post('kspgAPI/CouponOperations/rejectInvalidCoupon', { id })
        .then((response) => {
          this.SuccessMessage = response.data.message;
          setTimeout(() => {
            this.getInvalidCoupons(this.currentPage);
            this.SuccessMessage = '';
          }, 2000);
        })
        .catch((e) => {
          this.ErrorMessage = (e.response && e.response.data && e.response.data.message) || 'Error rejecting coupon';
          setTimeout(() => { this.ErrorMessage = ''; }, 4000);
        })
        .finally(() => {
          loader && loader.hide();
          this.skyloEnd && this.skyloEnd();
        });
    },
    cancelRejectCoupon() {
      this.showRejectModal = false;
      this.selectedRejectCouponId = null;
    },
    
    getStatusClass(status) {
      switch(status) {
        case 'Accepted':
          return 'label label-success';
        case 'Rejected':
          return 'label label-danger';
        case 'Invalid':
          return 'label label-warning';
        default:
          return 'label label-info';
      }
    },
    openAcceptModal(item) {
      this.selectedCoupon = item;
      this.selectedProduct = null;
      this.selectedReborer = null;
      this.acceptFormError = '';
      this.showAcceptModal = true;
      this.loadProductsList();
      this.loadReborersList(item.scanner_user_id);
    },
    closeAcceptModal() {
      this.showAcceptModal = false;
      this.selectedCoupon = null;
      this.selectedProduct = null;
      this.selectedReborer = null;
      this.acceptFormError = '';
    },
    async loadProductsList() {
      try {
        const params = { page: 0, size: 1000, Active: 1 };
        const response = await commonServices.get('kspgAPI/Product/list', params);
        this.productsList = response.data && response.data.product_data ? response.data.product_data : [];
      } catch (e) {
        // Handle error silently or show user-friendly message
        this.productsList = [];
        this.ErrorMessage = 'Error loading products. Please try again.';
        setTimeout(() => { this.ErrorMessage = ''; }, 4000);
      }
    },

    async loadReborersList(scannerUserId = null) {
      try {
        const params = { page: 0, size: 5000, PartnerTypeSelected: 'Reborer' };
        const response = await commonServices.get('kspgAPI/Partners/Reportlist', params);
        this.reborersList = response.data && response.data.users_data ? response.data.users_data : [];
        
        // Pre-select the scanned user if provided
        if (scannerUserId && this.reborersList.length > 0) {
          // Try to find by user_id first
          let scannedUser = this.reborersList.find(reborer => reborer.id == scannerUserId);
          
          // If not found, try to find by entity_id
          if (!scannedUser && this.selectedCoupon) {
            scannedUser = this.reborersList.find(reborer => reborer.entity_id == this.selectedCoupon.scanner_entity_id);
          }
          
          // If still not found, try to find by email
          if (!scannedUser && this.selectedCoupon) {
            scannedUser = this.reborersList.find(reborer => reborer.email == this.selectedCoupon.partner_email);
          }
          
          if (scannedUser) {
            this.selectedReborer = scannedUser;
                      } else {
            // If scanned user is not in reborer list, add them as a custom entry
            if (this.selectedCoupon) {
              const userDetails = {
                id: this.selectedCoupon.scanner_user_id,
                entity_id: this.selectedCoupon.scanner_entity_id,
                first_name: this.selectedCoupon.partner_first_name || 'Unknown',
                last_name: this.selectedCoupon.partner_last_name || 'User',
                email: this.selectedCoupon.partner_email || '',
                UserCode: 'SCANNER-' + this.selectedCoupon.scanner_user_id
              };
              this.reborersList.unshift(userDetails); // Add to beginning of list
              this.selectedReborer = userDetails;
            }
          }
        }
      } catch (e) {
        // Handle error silently or show user-friendly message
        this.reborersList = [];
        this.ErrorMessage = 'Error loading reborers. Please try again.';
        setTimeout(() => { this.ErrorMessage = ''; }, 4000);
      }
    },

    formatProductLabel(product) {
      if (!product) return '';
      const code = product.ProductName || '';
      const type = product.ProductType ? ` - ${product.ProductType}` : '';
      return `${code}${type}`;
    },

    formatReborerLabel(reborer) {
      if (!reborer) return '';
      const name = `${reborer.first_name || ''} ${reborer.last_name || ''}`.trim();
      const code = reborer.UserCode ? ` - ${reborer.UserCode}` : '';
      return `${name}${code}`;
    },

    async submitAcceptCoupon() {
      if (!this.selectedProduct) {
        this.acceptFormError = 'Please select a product.';
        return;
      }
      
      this.acceptFormError = '';
      let loader = this.$loading ? this.$loading.show() : null;
      
      try {
        // Submit coupon with selected product and optional reborer
        await commonServices.post('kspgAPI/CouponOperations/acceptInvalidCoupon', {
          id: this.selectedCoupon.id,
          product_id: this.selectedProduct.id,
          point_per_unit: this.selectedProduct.PointPerUnit,
          reborer_entity_id: this.selectedReborer ? this.selectedReborer.entity_id : null,
          reborer_user_id: this.selectedReborer ? this.selectedReborer.id : null,
          update_scanner: !!this.selectedReborer // Flag to indicate if we want to update scanner info
        });
        
        // Update the points and status in the table data for the selected coupon
        const couponIndex = this.invalid_coupons_data.findIndex(coupon => coupon.id === this.selectedCoupon.id);
        if (couponIndex !== -1) {
          this.invalid_coupons_data[couponIndex].points = this.selectedProduct.PointPerUnit;
          this.invalid_coupons_data[couponIndex].status = 'Accepted';
        }
        
        this.SuccessMessage = 'Coupon accepted successfully.';
        this.closeAcceptModal();
        setTimeout(() => {
          this.getInvalidCoupons(this.currentPage);
          this.SuccessMessage = '';
        }, 2000);
      } catch (e) {
        this.ErrorMessage = (e.response && e.response.data && e.response.data.message) || 'Error accepting coupon';
        setTimeout(() => { this.ErrorMessage = ''; }, 4000);
      } finally {
        if (loader) loader.hide();
      }
    },
    
  },
  mounted() {
    
    this.getInvalidCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY HH:mm:ss');
    },
  },
};
</script>

<style scoped>

.btn-success.btn-xs.text-white:hover {
  background-color: #218838 !important;
  color: #fff !important;
}

.btn-danger.btn-xs.text-white:hover {
  background-color: #c82333 !important;
  color: #fff !important;
}

.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align {
  text-align: left !important;
}
.label-danger {
  background-color: #d9534f;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
}
.text-white {
  color: #fff !important;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.btn-success.text-white {
  background-color: #28a745 !important;
  color: #fff !important;
  border: none;
}

.btn-success.text-white:hover,
.btn-success.text-white:focus,
.btn-success.text-white:active {
  background-color: #218838 !important;
  color: #fff !important;
}

/* Status filter styling */
#statusFilter {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  background-color: #fff;
}

#statusFilter:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

label[for="statusFilter"] {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
  display: block;
}

/* Status label styling */
.label {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  color: white;
}

.label-success {
  background-color: #28a745;
}

.label-danger {
  background-color: #dc3545;
}

.label-warning {
  background-color: #ffc107;
  color: #212529;
}

.label-info {
  background-color: #17a2b8;
}
</style>